import React from 'react';
import {Link} from 'react-router-dom';

export class MainPanel extends React.Component {
    render(){
        
        return (
            <section className="section main-container main">
                <div className=" columns">
                    <div className="column is-9">
                        <div className="columns is-vcentered main-container-content">
                            <div className="column is-7 is-offset-1">
                                <div className="is-size-3"> Security. Liquidity. Trust</div>
                                <p className="m-t-md">
                                HWG Exchange is a LFSA licensed exchange for fiat and digital assets. Buy, sell and store fiat and digital assets through our designated client’s account. 
                                </p>
                                <div className="m-t-xl">
                                    <Link to="/register">
                                        <button className="button is-primary is-outlined">
                                            Open Account
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Views/HomePage/MainPanel.jsx